/*!
 * CookieInco — cookie consent for Shopify (USA / CCPA-CPRA opt-out model).
 * Pair with snippets/cookieinco-head.liquid, which must run first in <head>.
 *
 * Trackers covered: GA4 (Google Consent Mode v2), Meta Pixel (fbq consent),
 * Shopify Customer Privacy API. Honors Global Privacy Control.
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'cc_consent';
  var COOKIE_TTL_DAYS = 365;
  var POLICY_VERSION = 1; // bump to re-prompt everyone after policy changes

  var TEXTS = {
    brand: 'MOYCHAY.COM',
    tagline: 'in tea we trust',
    body: 'We use cookies to personalize content and ads, to provide social ' +
      'media features and to analyze our traffic. We also share information ' +
      'about your use of our site with our social media, advertising and ' +
      'analytics partners who may combine it with other information that ' +
      'you’ve provided to them or that they’ve collected from your ' +
      'use of their services.',
    declineAll: 'Decline all',
    saveSelection: 'Save selection',
    acceptAll: 'Accept all',
    gpcNote: 'Your browser sent a Global Privacy Control signal, so tracking is off by default.',
    categories: {
      necessary: {
        label: 'Necessary',
        desc: 'Required for the store to work: cart, checkout, security. Always on.'
      },
      analytics: {
        label: 'Analytics',
        desc: 'Google Analytics — helps us understand how the store is used.'
      },
      marketing: {
        label: 'Advertising',
        desc: 'Meta Pixel and ad platforms — ad measurement and personalization. ' +
          'Opting out is your "Do Not Sell or Share My Personal Information" right.'
      }
    }
  };

  // ---------------------------------------------------------------- storage

  function readConsent() {
    var m = document.cookie.match(/(?:^|;\s*)cc_consent=([^;]+)/);
    if (!m) return null;
    try {
      var c = JSON.parse(decodeURIComponent(m[1]));
      return (c && c.v === POLICY_VERSION) ? c : null;
    } catch (e) { return null; }
  }

  function writeConsent(analytics, marketing) {
    var value = {
      v: POLICY_VERSION,
      ts: Date.now(),
      analytics: !!analytics,
      marketing: !!marketing
    };
    var exp = new Date(Date.now() + COOKIE_TTL_DAYS * 864e5).toUTCString();
    document.cookie = COOKIE_NAME + '=' + encodeURIComponent(JSON.stringify(value)) +
      '; expires=' + exp + '; path=/; SameSite=Lax' +
      (location.protocol === 'https:' ? '; Secure' : '');
    return value;
  }

  // ---------------------------------------------------------------- apply

  function gtag() { (window.dataLayer = window.dataLayer || []).push(arguments); }

  function applyConsent(analytics, marketing) {
    gtag('consent', 'update', {
      analytics_storage: analytics ? 'granted' : 'denied',
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing ? 'granted' : 'denied',
      ad_personalization: marketing ? 'granted' : 'denied'
    });

    if (window.fbq) window.fbq('consent', marketing ? 'grant' : 'revoke');

    syncShopify(analytics, marketing);

    if (!analytics) clearCookies([/^_ga$/, /^_ga_/, /^_gid$/, /^_gat/]);
    if (!marketing) clearCookies([/^_fbp$/, /^_fbc$/]);

    try {
      document.dispatchEvent(new CustomEvent('cc:consent-changed', {
        detail: { analytics: analytics, marketing: marketing }
      }));
    } catch (e) { /* old browsers */ }
  }

  function syncShopify(analytics, marketing) {
    function set() {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: analytics,
          marketing: marketing,
          preferences: true,
          sale_of_data: marketing
        }, function () {});
      } catch (e) { /* API shape changed or unavailable — non-fatal */ }
    }
    if (window.Shopify && window.Shopify.customerPrivacy) {
      set();
    } else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (err) { if (!err) set(); }
      );
    }
  }

  function clearCookies(patterns) {
    var host = location.hostname;
    var domains = ['', host, '.' + host];
    var parts = host.split('.');
    if (parts.length > 2) domains.push('.' + parts.slice(-2).join('.'));
    document.cookie.split(';').forEach(function (pair) {
      var name = pair.split('=')[0].trim();
      if (!patterns.some(function (re) { return re.test(name); })) return;
      domains.forEach(function (d) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/' +
          (d ? '; domain=' + d : '');
      });
    });
  }

  // ---------------------------------------------------------------- UI

  // Palette lifted from moychay.nl: brand olive #556B2F, CookiFi-style card.
  var CSS =
    ':root{--cc-green:#6d8c4a;--cc-green-dark:#556b2f;--cc-green-pale:#dfe5d2;' +
    '--cc-border:#e3e3e3;--cc-text:#3d3d3d}' +
    '#cc-overlay{position:fixed;inset:0;z-index:2147483001;background:rgba(30,30,20,.5);' +
    'display:flex;align-items:center;justify-content:center;padding:16px;' +
    'font-family:"DM Sans",-apple-system,"Segoe UI",Roboto,sans-serif}' +
    '#cc-card{background:#fff;color:var(--cc-text);border-radius:6px;max-width:430px;' +
    'width:100%;max-height:90vh;overflow:auto;box-shadow:0 10px 40px rgba(0,0,0,.3)}' +
    '.cc-head{padding:14px 20px 10px;border-bottom:1px solid var(--cc-border);text-align:center}' +
    '.cc-brand{color:var(--cc-green-dark);font-weight:700;font-size:15px;' +
    'letter-spacing:3px;text-transform:uppercase}' +
    '.cc-tagline{color:var(--cc-green);font-size:11px;letter-spacing:1.5px;margin-top:2px}' +
    '.cc-body{padding:16px 20px;font-size:13px;line-height:1.55;text-align:justify}' +
    '.cc-gpc{margin:0 20px 12px;background:#f4f6ec;border-radius:4px;' +
    'padding:9px 12px;font-size:12px;color:var(--cc-green-dark)}' +
    '.cc-cats{display:flex;border-top:1px solid var(--cc-border);' +
    'border-bottom:1px solid var(--cc-border)}' +
    '.cc-cat{flex:1;padding:13px 6px 15px;text-align:center;' +
    'border-right:1px solid var(--cc-border);cursor:help}' +
    '.cc-cat:last-child{border-right:0}' +
    '.cc-cat b{display:block;font-size:12.5px;font-weight:600;margin-bottom:10px;color:#2c2c2c}' +
    '.cc-sw{display:inline-block;cursor:pointer}' +
    '.cc-sw input{position:absolute;opacity:0;pointer-events:none}' +
    '.cc-sw i{display:inline-block;position:relative;width:38px;height:20px;' +
    'border-radius:3px;background:var(--cc-green-pale);transition:background .15s}' +
    '.cc-sw i::after{content:"";position:absolute;left:2px;top:2px;width:16px;height:16px;' +
    'border-radius:2px;background:#fff;border:1px solid #c8c8c8;box-sizing:border-box;' +
    'transition:left .15s}' +
    '.cc-sw input:checked+i{background:var(--cc-green)}' +
    '.cc-sw input:checked+i::after{left:20px}' +
    '.cc-sw input:disabled+i{opacity:.55;cursor:default}' +
    '.cc-actions{display:flex;gap:8px;padding:14px 20px 10px;flex-wrap:wrap}' +
    '.cc-btn{flex:1;min-width:110px;padding:9px 6px;font-family:inherit;font-size:13px;' +
    'font-weight:500;border-radius:4px;cursor:pointer;white-space:nowrap}' +
    '.cc-btn--outline{background:#fff;border:1px solid var(--cc-green);color:var(--cc-green-dark)}' +
    '.cc-btn--outline:hover{background:#f4f6ec}' +
    '.cc-btn--fill{background:var(--cc-green);border:1px solid var(--cc-green);color:#fff}' +
    '.cc-btn--fill:hover{background:var(--cc-green-dark)}' +
    '.cc-foot{display:flex;justify-content:flex-end;padding:0 20px 12px;' +
    'font-size:11px;color:#aaa}';

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'text') node.textContent = attrs[k];
      else if (k.slice(0, 2) === 'on') node.addEventListener(k.slice(2), attrs[k]);
      else node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { node.appendChild(c); });
    return node;
  }

  // Single CookiFi-style centered dialog: first-visit banner and the settings
  // window are the same card. dismissible=true adds close-on-overlay-click.
  function showDialog(dismissible) {
    if (document.getElementById('cc-overlay')) return;
    var current = readConsent() || window.__ccEffective ||
      { analytics: true, marketing: true };

    function toggle(key, checked, disabled) {
      var cat = TEXTS.categories[key];
      var input = el('input', { type: 'checkbox', 'data-cc-cat': key });
      input.checked = checked;
      input.disabled = !!disabled;
      return el('div', { 'class': 'cc-cat', title: cat.desc }, [
        el('b', { text: cat.label }),
        el('label', { 'class': 'cc-sw' }, [input, el('i', {})])
      ]);
    }

    var children = [
      el('div', { 'class': 'cc-head' }, [
        el('div', { 'class': 'cc-brand', text: TEXTS.brand }),
        el('div', { 'class': 'cc-tagline', text: TEXTS.tagline })
      ]),
      el('div', { 'class': 'cc-body', text: TEXTS.body })
    ];
    if (window.__ccEffective && window.__ccEffective.fromGpc) {
      children.push(el('p', { 'class': 'cc-gpc', text: TEXTS.gpcNote }));
    }
    children.push(
      el('div', { 'class': 'cc-cats' }, [
        toggle('necessary', true, true),
        toggle('analytics', current.analytics !== false),
        toggle('marketing', current.marketing !== false)
      ]),
      el('div', { 'class': 'cc-actions' }, [
        el('button', {
          'class': 'cc-btn cc-btn--outline', text: '⊘ ' + TEXTS.declineAll,
          onclick: function () { decide(false, false); }
        }),
        el('button', {
          'class': 'cc-btn cc-btn--outline', text: TEXTS.saveSelection,
          onclick: function () {
            var get = function (k) {
              return document.querySelector('#cc-card [data-cc-cat=' + k + ']').checked;
            };
            decide(get('analytics'), get('marketing'));
          }
        }),
        el('button', {
          'class': 'cc-btn cc-btn--fill', text: '✓ ' + TEXTS.acceptAll,
          onclick: function () { decide(true, true); }
        })
      ]),
      el('div', { 'class': 'cc-foot', text: 'CookieInco' })
    );

    var overlay = el('div', {
      id: 'cc-overlay',
      onclick: function (e) {
        if (dismissible && e.target === overlay) overlay.remove();
      }
    }, [el('div', {
      id: 'cc-card', role: 'dialog', 'aria-modal': 'true', 'aria-label': TEXTS.brand
    }, children)]);
    document.body.appendChild(overlay);
  }

  function openSettings() { showDialog(true); }

  function decide(analytics, marketing) {
    writeConsent(analytics, marketing);
    applyConsent(analytics, marketing);
    var o = document.getElementById('cc-overlay');
    if (o) o.remove();
  }

  // ---------------------------------------------------------------- boot

  function boot() {
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    var stored = readConsent();
    if (stored) {
      // Re-sync every page load: Shopify Privacy API and fbq state don't persist.
      applyConsent(stored.analytics !== false, stored.marketing !== false);
    } else if (window.__ccEffective && window.__ccEffective.fromGpc) {
      // GPC signal without a stored choice: persist the opt-out, skip the banner.
      decide(false, false);
    } else {
      // Opt-out model: trackers already run via head defaults; still sync Shopify
      // so its own pixels align, and show the consent dialog.
      syncShopify(true, true);
      showDialog(false);
    }

    // Public API — e.g. footer link:
    // <a href="#" onclick="CookieInco.openSettings();return false">Do Not Sell or Share My Personal Information</a>
    window.CookieInco = {
      openSettings: openSettings,
      getConsent: readConsent,
      optOut: function () { decide(false, false); }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
